var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"lefttitle"},[_vm._v("校服售后PC端")]),_c('div',{staticClass:"right"},[_c('img',{attrs:{"src":"/assets/1-1.8@2x.png","alt":""}}),_c('span',{staticClass:"lefttitle",on:{"click":_vm.outlogin}},[_vm._v("退出")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }